<template>
  <div class="container">
    <div class="map-box">
      <Map v-model="center" />
      <div class="map-text">
        <div class="text-info">
          <div>{{ hospitalInfo.contactPersonPhone }}</div>
          <div>{{ hospitalInfo.address }}</div>
        </div>
      </div>
      <div class="bg"></div>
    </div>
    <div class="kong"></div>
    <div class="actions">
      <van-grid :gutter="10" :column-num="3">
        <van-grid-item text="医院概况" to="/hospital/basic">
          <span slot="icon">
            <i class="iconfont icon-hospital" />
          </span>
        </van-grid-item>

        <van-grid-item text="科室介绍" to="/hospital/department">
          <span slot="icon">
            <i class="iconfont icon-flow" />
          </span>
        </van-grid-item>

        <van-grid-item
          text="价格查询"
          to="/hospital/priceQuery"
          v-if="SettingList.enabledGoodsPriceSelect"
        >
          <span slot="icon">
            <i class="iconfont icon-moeny" />
          </span>
        </van-grid-item>

        <van-grid-item text="医院公告" to="/hospital/news">
          <span slot="icon">
            <i class="iconfont icon-notice" />
          </span>
        </van-grid-item>

        <van-grid-item text="地图导航" to="/hospital/map">
          <span slot="icon">
            <i class="iconfont icon-direction" />
          </span>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="kong"></div>
    <div class="box">
      <div class="label-title">推荐医生</div>
      <div class="card-list">
        <ul>
          <li
            v-for="item in DoctorList"
            :key="item.id"
            @click="toDoctorInfo(item)"
          >
            <img :src="getAvatarUrl(item.headImgUrl)" :alt="item.name" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getAvatarUrl, cache } from "@/utils/common";
import { Grid, GridItem, Icon } from "vant";
import Map from "@/components/Map";
export default {
  name: "hospitalIndex",
  components: {
    Map,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
  },
  data() {
    return {
      DoctorList: [],
      SettingList: {},
    };
  },
  computed: {
    ...mapState({
      hospitalInfo: (state) => state.app.hospitalInfo,
    }),
    center() {
      return this.hospitalInfo.coordinateAddress
        ? this.hospitalInfo.coordinateAddress.split(",")
        : [];
    },
  },
  created() {
    if (!(this.hospitalInfo && this.hospitalInfo.id)) {
      this.getHospitalInfo();
    }
    this.getDoctorList();
    this.SettingList = cache.get("user");
  },
  methods: {
    ...mapActions(["getHospitalInfo"]),
    getAvatarUrl,

    getDoctorList() {
      this.$post("Doctor_Recommend", {
        PageIndex: 0,
        PageSize: 100,
      }).then((res) => {
        this.DoctorList = res.data.datas;
      });
    },
    toDoctorInfo(item) {
      this.$router.push({
        name: "hospitalDoctorInfo",
        query: {
          Id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.map-box {
  position: relative;
  .map-text {
    font-size: 0.35rem;
    position: absolute;
    left: 0;
    height: 1rem;
    bottom: 0.4rem;
    width: 100%;
    padding: 0 0.3rem 0 0.3rem;
    background: #fff;
    z-index: 210;
    background: -webkit-linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    background: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ); /* 标准的语法 */
    .text-info {
      position: absolute;
      bottom: -0.2rem;
    }
  }
  .bg {
    content: "";
    position: absolute;
    bottom: 0rem;
    left: 0;
    width: 100%;
    height: 0.45rem;
    background: #fff;
    z-index: 200;
  }
}
.actions {
  margin: 0.5rem 0;
  i {
    color: #999;
  }
}
.card-list {
  overflow: hidden;
  overflow-x: auto;
  margin: 0.5rem 0;
  ul {
    white-space: nowrap;
    li {
      width: 2rem;
      height: 2rem;
      border-radius: 2rem;
      overflow: hidden;
      display: inline-block;
      font-size: 0.35rem;
      text-align: center;
      color: #555;
      & + li {
        margin-left: 0.3rem;
      }
      img {
        width: 100%;
      }
    }
  }
}
</style>
